import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ItemService from "../../../services/ItemsServices";
import ItemCategoryService from "../../../services/ItemCategoryService";

import ProjectCategoryService from "../../../services/ProjectCategoryService";
import UomService from "../../../services/UomService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListItems from "../Components/ListItems";
import MessageDialog from "../../../components/MessageDialog";
import * as XLSX from "xlsx-js-style";
import StorageService from "../../../services/StorageService";
import utility from "../../../utils/utility";

export default function ViewItems() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [selectedCategory, setSelectedCategory] = useState("");
  const [itemCategories, setItemCategories] = useState([]);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
const [categorySearch, setCategorySearch] = useState("");
const categoryDropdownRef = useRef(null);
  const [uoms, setUoms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;


  const fetchData = async () => {
    setLoading(true);
    try {
      const [itemsRes, projectsRes, uomsRes] = await Promise.all([
        ItemService.getAllItems(currentPage, itemsPerPage, searchText,selectedCategory),
        // ItemCategoryService.getAll(),
        ProjectCategoryService.getAll(),
        UomService.getAll(),
      ]);

      const data = itemsRes?.data || [];
      const total = itemsRes?.total || 0;

      setItems(data);
      setPageCount(Math.ceil(total / itemsPerPage));

      // setItemCategories(categoriesRes.data || categoriesRes || []);
      setItemCategories(itemsRes?.categories || []);
      setUoms(
        (uomsRes.data || uomsRes || []).filter(
          (u) => u.status?.toLowerCase() === "active"
        )
      );
    } catch (err) {
      console.error(err);
      showMessage("Error fetching data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, searchText,selectedCategory]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText,selectedCategory]);

  useEffect(() => {
    if (location.state?.refresh) {
      fetchData();
      navigate(location.pathname, { replace: true });
    }
  }, [location]);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      categoryDropdownRef.current &&
      !categoryDropdownRef.current.contains(event.target)
    ) {
      setShowCategoryDropdown(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handleAdd = () => {
    navigate("/cpnl/items/add");
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  const handleModify = () => {
    if (!selected) {
      showMessage("Select one item to modify");
      return;
    }
    navigate(`/cpnl/items/add/${selected}`);
  };

  const handleToggleStatus = async (item) => {
    const newStatus = item.status === "Active" ? "Inactive" : "Active";
    if (!window.confirm(`Are you sure do you want to change status as ${newStatus}?`))
      return;

    setLoading(true);
    try {
      await ItemService.updateStatus(item.id, newStatus);
      showMessage("Status updated successfully", "success");
      fetchData();
    } catch (err) {
      console.error(err);
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  //  EXCEL EXPORT FUNCTION
  const handleExportToExcel = async () => {
    try {
      setLoading(true);
      
      // Check if filters are applied
      const hasFilters = searchText.trim() !== "" || selectedCategory !== "";
      
      let dataToExport = [];
      
      if (hasFilters) {
        // Export filtered data (current page data)
        dataToExport = filteredItems;
      } else {
        // Fetch all data without pagination for export
        const allItemsRes = await ItemService.getAllItems(1, 10000, "", "");
        dataToExport = allItemsRes?.data || [];
      }

      if (dataToExport.length === 0) {
        showMessage("No data available to export", "error");
        setLoading(false);
        return;
      }

      // Get company info
      const activeCompany = StorageService.activeCompany();
      const companyName = activeCompany?.companyName || "Company";
      const currentDate = new Date();
      const reportDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

      // Create workbook and worksheet
      const workbook = XLSX.utils.book_new();
      const worksheet = {};
      worksheet["!merges"] = [];
      worksheet["!cols"] = [
        { wch: 20 },  // A - Item Category
        { wch: 28 },  // B - Item Name
        { wch: 35 },  // C - Description
        { wch: 15 },  // D - UOM
        { wch: 15 },  // E - Status
        { wch: 20 },  // F - Report Date
      ];

      let row = 0;

      // Styles
      const companyNameStyle = {
        font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
        alignment: { horizontal: "center", vertical: "center" },
      };

      // const logoStyle = {
      //   font: { sz: 10, color: { rgb: "1F4E78" } },
      //   alignment: { horizontal: "center", vertical: "center" },
      // };

      const reportTitleStyle = {
        font: { bold: true, sz: 14, color: { rgb: "1F4E78" } },
        alignment: { horizontal: "center", vertical: "center" },
      };

      const reportDateStyle = {
        font: { bold: true, sz: 10, color: { rgb: "000000" } },
        alignment: { horizontal: "right", vertical: "center" },
      };

      const headerStyle = {
        fill: { fgColor: { rgb: "4472C4" } },
        font: { bold: true, sz: 11, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };

      const cellStyle = {
        alignment: { horizontal: "left", vertical: "center" },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };

      // ===== HEADER ROW 1 =====
      // Company Name
      XLSX.utils.sheet_add_aoa(worksheet, [[companyName]], {
        origin: { r: row, c: 0 },
      });

      worksheet[
        XLSX.utils.encode_cell({ r: row, c: 0 })
      ].s = companyNameStyle;

      // Middle: Report Title
      XLSX.utils.sheet_add_aoa(worksheet, [["Items Report"]], {
        origin: { r: row, c: 1 },
      });
      worksheet["!merges"].push({
        s: { r: row, c: 1 },
        e: { r: row, c: 2 },
      });
      worksheet[XLSX.utils.encode_cell({ r: row, c: 1 })].s = reportTitleStyle;

      // Right: Report Date
      XLSX.utils.sheet_add_aoa(worksheet, [[`Report Date: ${reportDate}`]], {
        origin: { r: row, c: 4 },
      });
      worksheet[XLSX.utils.encode_cell({ r: row, c: 4 })].s = reportDateStyle;

      row += 2;

      // ===== FILTER INFORMATION =====

      // Item Category Label
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [["Item Category:"]],
        {
          origin: { r: row, c: 0 },
        }
      );

      worksheet[
        XLSX.utils.encode_cell({ r: row, c: 0 })
      ].s = {
        font: {
          bold: true,
          sz: 11,
        },
        alignment: {
          horizontal: "left",
          vertical: "center",
        },
      };

      // Item Category Value
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [[
          selectedCategory
            ? itemCategories.find(
                (cat) => String(cat.id) === String(selectedCategory)
              )?.itemCategoryName || "Selected Category"
            : "All Categories"
        ]],
        {
          origin: { r: row, c: 1 },
        }
      );

      // Search Label
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [["Search:"]],
        {
          origin: { r: row, c: 2 },
        }
      );

      worksheet[
        XLSX.utils.encode_cell({ r: row, c: 2 })
      ].s = {
        font: {
          bold: true,
          sz: 11,
        },
        alignment: {
          horizontal: "left",
          vertical: "center",
        },
      };

      // Search Value
      XLSX.utils.sheet_add_aoa(
        worksheet,
        [[searchText.trim() || "All Items"]],
        {
          origin: { r: row, c: 3 },
        }
      );

      row += 2;

      // ===== TABLE HEADERS =====
      const headers = [
        "Item Category",
        "Item Name",
        "Description",
        "UOM",
        "Status",
      ];

      XLSX.utils.sheet_add_aoa(worksheet, [headers], {
        origin: { r: row, c: 0 },
      });

      // Style header row
      for (let i = 0; i < headers.length; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: i });
        if (worksheet[cellAddress]) {
          worksheet[cellAddress].s = headerStyle;
        }
      }

      row += 1;

      // ===== DATA ROWS =====
      dataToExport.forEach((item) => {
        const rowData = [
          item.itemCategoryName || "",
          item.itemCode || "",
          item.itemDescription || "",
          item.uomName || "",
          item.status || "",
        ];

        XLSX.utils.sheet_add_aoa(worksheet, [rowData], {
          origin: { r: row, c: 0 },
        });

        // Apply cell styling
        for (let i = 0; i < rowData.length; i++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: i });
          if (worksheet[cellAddress]) {
            worksheet[cellAddress].s = cellStyle;
          }
        }

        row += 1;
      });

      // Add worksheet to workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Items");

      // Generate filename
      // const timestamp = new Date().toISOString().slice(0, 10);
      // const filename = hasFilters
      //   ? `Items_Filtered_${timestamp}.xlsx`
      //   : `Items_All_${timestamp}.xlsx`;

      // Generate filename: Items_ItemFilter_DD-MM-YYYY.xlsx

const formattedDate =
  `${String(currentDate.getDate()).padStart(2, "0")}-` +
  `${String(currentDate.getMonth() + 1).padStart(2, "0")}-` +
  `${currentDate.getFullYear()}`;

const itemFilterName = searchText.trim()
  ? searchText.trim()
  : "AllItems";

// Remove characters that are not suitable for a filename
const safeItemFilterName = itemFilterName.replace(/[\\/:*?"<>|]/g, "_");

const filename = `Items_${safeItemFilterName}_${formattedDate}.xlsx`;

      // Write file
      XLSX.writeFile(workbook, filename);
      showMessage("Excel file exported successfully", "success");
    } catch (err) {
      console.error(err);
      showMessage("Error exporting to Excel", "error");
    } finally {
      setLoading(false);
    }
  };

  //  FRONTEND SEARCH FILTER
  // const filteredItems = items.filter(
  //   (item) =>
  //     // item.itemName?.toLowerCase().includes(searchText.toLowerCase()) ||
  //     item.itemCode?.toLowerCase().includes(searchText.toLowerCase())
  // );
  const filteredItems = items;

  return (
    <>
      <Breadcrumb pageTitle="Item" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">

          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-3 p-2`}
            >
              <span>{message}</span>
              <button className="btn-close" onClick={closeMessage}></button>
            </div>
          )} */}

          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />


          {/*  SEARCH + ACTION BUTTONS */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div
              ref={categoryDropdownRef}
              className="position-relative"
              style={{ width: "220px" }}
            >
              <label className="form-label mb-1">Item Category</label>

              {/* Selected Category / Search Input */}
              <input
                type="text"
                className="form-control"
                placeholder="Search Item Category"
                value={
                  selectedCategory
                    ? (
                        itemCategories.find(
                          (category) =>
                            String(category.id) === String(selectedCategory)
                        )?.itemCategoryName || ""
                      )
                    : categorySearch
                }
                onFocus={() => {
                  setShowCategoryDropdown(true);
                }}
                onChange={(e) => {
                  setCategorySearch(e.target.value);
                  setSelectedCategory("");
                  setShowCategoryDropdown(true);
                }}
              />

              {showCategoryDropdown && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 1050,
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                >

                  {/* All Categories */}
                  <div
                    className="px-3 py-2"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setSelectedCategory("");
                      setCategorySearch("");
                      setShowCategoryDropdown(false);
                    }}
                  >
                    All Categories
                  </div>

                  {/* Categories */}
                  {itemCategories
                    .filter((category) =>
                      category.itemCategoryName
                        ?.toLowerCase()
                        .includes(categorySearch.toLowerCase())
                    )
                    .map((category) => (
                      <div
                        key={category.id}
                        className="px-3 py-2"
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedCategory(category.id);
                          setCategorySearch("");
                          setShowCategoryDropdown(false);
                        }}
                      >
                        {category.itemCategoryName}
                      </div>
                    ))}

                  {/* No Results */}
                  {itemCategories.filter((category) =>
                    category.itemCategoryName
                      ?.toLowerCase()
                      .includes(categorySearch.toLowerCase())
                  ).length === 0 && (
                    <div className="px-3 py-2 text-muted">
                      No categories found
                    </div>
                  )}

                </div>
              )}
            </div>

            <div>
              <label className="form-label mb-1">Item Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search Item Name"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>


            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>

              <button
                className="d-inline-flex btn btn-info"
                onClick={handleExportToExcel}
                disabled={loading}
                title={`Export ${searchText.trim() !== "" || selectedCategory !== "" ? "filtered" : "all"} data`}
              >
                <i className="ti ti-download me-1"></i> Export to Excel
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListItems
            loading={loading}
            filteredItems={filteredItems}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            uoms={uoms}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />

        </div>
      </div>
    </>
  );
}
